/**
 * Members Translations Module (Spanish)
 * Matches English structure exactly
 * @module members
 * @language es
 */

export const members = {
  memberInsightsPage: {
    pageSubtitle: "Demografía, Motivaciones y Resultados de Encuesta de Experiencia de 3,790+ encuestados"
  },
  membershipExperience: {
    title: "Encuesta de Experiencia de Miembros",
    subtitle: "Comprender la satisfacción y engagement de miembros en todos los puntos de contacto",
    overallSatisfaction: "Satisfacción General",
    programQuality: "Calidad del Programa",
    networkingOpportunities: "Oportunidades de Networking",
    satisfactionMetrics: "Métricas de Satisfacción",
    npsBreakdown: "Desglose de NPS",
    benefitsValue: "Valor de Beneficios",
    membershipJourney: "Jornada de Membresía",
    general: "Satisfacción General",
    eventQuality: "Calidad de Eventos",
    networking: "Networking",
    personalDevelopment: "Desarrollo Personal",
    leadership: "Liderazgo",
    community: "Engagement Comunitario",
    target: "Meta",
    npsScore: "Puntuación NPS",
    excellent: "Excelente",
    retentionRate: "Tasa de Retención",
    recommendation: "Recomendaría",
    promoters: "Promotores",
    neutrals: "Neutrales",
    detractors: "Detractores",
    professionalNetworking: "Networking Profesional",
    leadershipDevelopment: "Desarrollo de Liderazgo",
    personalGrowth: "Crecimiento Personal",
    careerOpportunities: "Oportunidades de Carrera",
    communicationSkills: "Habilidades de Comunicación",
    socialResponsibility: "Responsabilidad Social",
    businessKnowledge: "Conocimiento Empresarial",
    internationalConnections: "Conexiones Internacionales",
    high: "Alto",
    medium: "Medio",
    low: "Bajo",
    firstYear: "Primer Año",
    secondThirdYear: "2do-3er Año",
    fourthFifthYear: "4to-5to Año",
    fivePlusYears: "5+ Años",
    satisfaction: "Satisfacción",
    engagement: "Engagement",
    retention: "Retención"
  },
  occupation: {
    title: "Análisis Ocupacional e Industrial",
    subtitle: "Perfil profesional detallado de miembros JCI",
    leadership: "Liderazgo",
    entrepreneurs: "Emprendedores",
    mainSectors: "Sectores Principales",
    careerSatisfaction: "Satisfacción Profesional",
    goalOriented: "Orientados a Metas",
    industryDistribution: "Distribución por Industria",
    occupationalLevels: "Niveles Ocupacionales",
    hierarchicalLevels: "Jerárquicos",
    entrepreneurialProfile: "Perfil Emprendedor",
    careerStages: "Etapas de Carrera",
    professionalGoals: "Metas Profesionales",
    salaryRanges: "Rangos Salariales",
    technology: "Tecnología",
    financialServices: "Servicios Financieros",
    consulting: "Consultoría",
    ecommerce: "Comercio Electrónico",
    health: "Salud",
    education: "Educación",
    marketing: "Marketing",
    manufacturing: "Manufactura",
    realEstate: "Bienes Raíces",
    others: "Otros"
  },
  memberProfile: {
    title: "Perfil de Miembro JCI",
    surveyDescription: "Encuesta de Experiencia de Membresía 2025 • 3,790 encuestados de todas las regiones",
    averageAge: "Edad Promedio",
    ageRange: "Rango: 18-40",
    universityEducated: "Educación Universitaria",
    degreesHeldPursuing: "Títulos obtenidos o en curso",
    entrepreneurs: "Emprendedores",
    selfEmployedMembers: "Miembros autoempleados",
    surveyRespondents: "Encuestados",
    allJCIAreas: "Las 4 Áreas JCI",
    ageGroupAnalysis: "Análisis por Grupo de Edad",
    coreAgeGroup: "Núcleo 28-40 años",
    ofMembers: "de miembros",
    challenges: "Desafíos",
    strengths: "Fortalezas",
    averageAgeByRegion: "Edad Promedio por Región",
    youngest: "Más Joven",
    oldest: "Mayor",
    membershipTenureAnalysis: "Análisis de Antigüedad de Membresía",
    newMembers: "Nuevos Miembros",
    strongOnboarding: "Fuerte proceso de incorporación",
    buildingFoundation: "Construyendo Base",
    developingSkills: "Desarrollando habilidades y red",
    activeContributors: "Contribuyentes Activos",
    peakEngagement: "Período de máximo engagement",
    experiencedLeaders: "Líderes Experimentados",
    mentorshipRoles: "Roles de mentoría y liderazgo",
    coreLeaders: "Líderes Centrales",
    institutionalKnowledge: "Conocimiento institucional",
    years: "años",
    freshEnergy: "Energía fresca",
    coreLeadership: "Líderes Centrales",
    alumniNetwork: "Red de Alumni",
    generationalContinuity: "Continuidad generacional a través de mentoría",
    alumniClubs: "Clubes de Alumni",
    nations: "Naciones",
    avgStay: "Estancia Prom.",
    alumniTransition: "Transición 40+ a Alumni",
    insight: "Perspectiva",
    leadershipProgression: "Progresión de Liderazgo",
    localChapterLeaders: "Líderes de Organizaciones Locales",
    foundationOfJCI: "Base de JCI",
    nationalDirectors: "Directores Nacionales",
    regionalLeadership: "Liderazgo regional",
    jciSenators: "Senadores JCI",
    distinguishedAlumni: "Alumni distinguidos",
    internationalOfficers: "Oficiales Internacionales",
    globalLeadership: "Cohorte de liderazgo global",
    majority: "Mayoría",
    significant: "Significativo",
    growing: "Creciente",
    educationalAttainment: "Nivel Educativo",
    employmentDistribution: "Distribución de Empleo",
    bachelorsDegree: "Licenciatura",
    mastersDegree: "Maestría",
    mastersEnrolled: "Maestría (Cursando)",
    phdPursuing: "Doctorado en Curso",
    technicalVocational: "Técnico/Vocacional",
    fullTimeEmployed: "Empleado Tiempo Completo",
    entrepreneurSelfEmployed: "Emprendedor/Autónomo",
    student: "Estudiante",
    other: "Otro",
    universityDegrees: "97%+ de miembros JCI tienen o cursan títulos universitarios",
    entrepreneursInsight: "31% son emprendedores o autónomos",
    industryDiversity: "Diversidad de Industrias",
    primarySectors: "Sectores principales representados por miembros JCI",
    education: "Educación",
    technology: "Tecnología",
    finance: "Finanzas",
    healthcare: "Salud",
    nonprofit: "Sin Fines de Lucro",
    government: "Gobierno",
    manufacturing: "Manufactura",
    services: "Servicios",
    careerEntry: "Entrada Laboral",
    financialIndependence: "Independencia Financiera",
    leadershipPositions: "Posiciones de Liderazgo",
    workLifeBalance: "Balance Vida-Trabajo",
    communityImpact: "Impacto Comunitario",
    ageGroupChallenges: "Desafíos por Grupo de Edad",
    ageGroupStrengths: "Fortalezas por Grupo de Edad",
    familyResponsibilities: "Responsabilidades familiares",
    careerGrowth: "Demandas de crecimiento profesional",
    workPressure: "Presión laboral",
    experience: "Experiencia",
    leadership: "Liderazgo",
    focus: "Enfoque",
    workLifeIntegration: "Integración vida-trabajo",
    leadershipDemands: "Demandas de liderazgo",
    mentorship: "Habilidades de mentoría",
    strategicThinking: "Pensamiento estratégico",
    networkBuilding: "Construcción de red",
    educationBalance: "Balance Educativo",
    digitalNative: "Nativo Digital",
    freshPerspective: "Perspectiva Fresca",
    enthusiasm: "Entusiasmo",
    careerDevelopment: "Desarrollo Profesional",
    financialPressure: "Presión Financiera",
    networking: "Networking",
    ambition: "Ambición",
    innovation: "Innovación",
    timeForMentoring: "Tiempo para Mentoría",
    industryExpertise: "Experiencia en Industria"
  },
  memberMotivations: {
    title: "Motivaciones y Valores de Miembros",
    subtitle: "Qué impulsa el engagement de miembros JCI",
    whyJoinJCI: "Por qué los Miembros se Unen a JCI",
    coreMotivations: "Motivaciones Principales",
    personalGrowth: "Crecimiento Personal",
    personalGrowthDesc: "Autodesarrollo y construcción de habilidades",
    leadershipDevelopment: "Desarrollo de Liderazgo",
    leadershipDesc: "Habilidades y experiencia de liderazgo",
    networking: "Networking",
    networkingDesc: "Conexiones profesionales y sociales",
    communityImpact: "Impacto Comunitario",
    communityDesc: "Hacer una diferencia localmente",
    careerOpportunities: "Oportunidades de Carrera",
    careerDesc: "Avance profesional",
    businessDevelopment: "Desarrollo Empresarial",
    businessDesc: "Hacer crecer su negocio o carrera",
    internationalExposure: "Exposición Internacional",
    internationalDesc: "Conexiones globales y viajes",
    socialBelonging: "Pertenencia Social",
    socialDesc: "Amistad y comunidad",
    ofRespondents: "de encuestados",
    topMotivation: "Motivación principal",
    benefitsRanking: "Ranking de Beneficios",
    benefitsCitation: "Principales beneficios citados por miembros en orden de importancia",
    leadershipTraining: "Capacitación en Liderazgo",
    professionalNetwork: "Red Profesional",
    personalDevelopment: "Desarrollo Personal",
    internationalConnections: "Conexiones Internacionales",
    communityService: "Servicio Comunitario",
    businessConnections: "Conexiones de Negocios",
    friendships: "Amistades",
    recognition: "Reconocimiento",
    valueDrivenMembership: "Membresía Orientada por Valores",
    valueDrivenDesc: "Los miembros JCI están principalmente motivados por el desarrollo personal (52%) e impacto (38%), siendo los beneficios de carrera motivadores secundarios.",
    riseProjects: "Proyectos RISE",
    peerMentorship: "Enfoque en mentoría entre pares",
    digitalSkillsWorkshops: "Talleres de Habilidades Digitales",
    increasingImportance: "Importancia creciente",
    keyInsightsTitle: "Perspectivas Clave de la Encuesta de Experiencia de Miembros 2025",
    memberPriorities: "Prioridades de Miembros",
    personalGrowthTop: "El crecimiento personal es el principal motivador (28%)",
    leadershipDrives: "El desarrollo de liderazgo impulsa el engagement (24%)",
    strongEmphasis: "Fuerte énfasis en networking y conexiones (21%)",
    commitmentService: "El compromiso con el servicio comunitario sigue siendo central (17%)",
    valueProposition: "Propuesta de Valor",
    jciDelivers: "JCI cumple con las expectativas de desarrollo de liderazgo",
    trainingValued: "Los programas de capacitación son altamente valorados (24%)",
    globalNetworkKey: "El acceso a la red global es un diferenciador clave",
    tangibleImpact: "Los miembros buscan oportunidades de impacto tangible",
    sources: "Fuentes: Encuesta de Experiencia de Miembros 2025 (3,790 encuestados) • Informe de Impacto JCI 2025",
    topSkill: "Principales Habilidades a Desarrollar",
    topSkills: "Principales Habilidades a Desarrollar",
    rankedByInterest: "Clasificadas por nivel de interés de miembros",
    survey2025: "Fuente: Encuesta de Experiencia de Miembros JCI 2025",
    communityBuilding: "Construcción de Comunidad y Servicio",
    priority1: "Prioridad 1",
    publicSpeaking: "Programas de oratoria y debate",
    criticalThinking: "Pensamiento Crítico y Resolución de Problemas",
    analysis: "Análisis y resolución estructurada de problemas",
    leadership: "Liderazgo y Construcción de Equipos",
    teamBuilding: "Habilidades de liderazgo y colaboración",
    emotionalIntelligence: "Inteligencia Emocional",
    selfAwareness: "Autoconocimiento y habilidades interpersonales",
    motivationAnalysis: "Análisis de Motivación",
    understandingMotivations: "Comprender qué impulsa el engagement de miembros JCI",
    memberExperienceSurvey: "Fuente: Encuesta de Experiencia de Miembros 2025",
    whyMembersJoin: "Por qué los Miembros se Unen a JCI",
    mostValuedBenefits: "Beneficios Más Valorados",
    accessToTraining: "Acceso a Capacitación y Certificaciones",
    professionalWorkshops: "Talleres y cursos profesionales",
    globalNetwork: "Red Global y Conexiones",
    internationalPartnerships: "Alianzas internacionales y networking",
    structuredPrograms: "Programas de desarrollo estructurados",
    growthThrough: "Crecimiento a través de experiencia y proyectos",
    topSkillsDevelopment: "Principales Habilidades a Desarrollar",
    communicationSkills: "Habilidades de Comunicación",
    leadershipOpportunities: "Oportunidades de Liderazgo",
    accessToRoles: "Acceso a roles y posiciones de liderazgo",
    professionalNetworking: "Networking Profesional",
    buildingConnections: "Construyendo conexiones profesionales",
    motivationsTitle: "Análisis de Motivación",
    connectionsAcross: "Conexiones entre regiones y países",
    impactOpportunities: "Oportunidades de Impacto",
    meaningfulChange: "Oportunidades para crear cambio significativo",
    leadershipTitle: "Liderazgo y Construcción de Equipos",
    publicSpeakingCompetitions: "Concursos de Oratoria",
    debatingChampions: "Campeones de Debate",
    viewProgramsEvents: "Ver Programas y Eventos",
    priorityNumber: "Prioridad #1",
    associatedPrograms: "Programas Asociados",
    viewPrograms: "Ver Programas",
    positiveImpact: "Creando impacto positivo en comunidades",
    communication: "Comunicación y Oratoria",
    leadershipManagement: "Liderazgo y Gestión",
    technicalSkills: "Habilidades Técnicas y Digitales",
    digitalLiteracy: "Alfabetización digital y habilidades tecnológicas",
    emerging: "Emergente",
    publicSpeakingCompetition: "Concurso de Oratoria",
    participants2024: "52 participantes (2024)",
    debatingChampionship: "Campeonato de Debate",
    participants57: "57 equipos (2024)",
    leadershipTrainingSessions: "Sesiones de Capacitación en Liderazgo",
    sessionsDelivered: "2,400+ sesiones impartidas",
    toypProgram: "Programa TOYP",
    globalRecognition: "Programa de reconocimiento global",
    leadershipWorkshops: "Talleres de Liderazgo",
    globalEventParticipants: "Múltiples eventos globales",
    surveySource: "Basado en la Encuesta de Experiencia de Miembros 2025 con 3,790 encuestados",
    skillsSource: "Datos de habilidades de la Encuesta de Experiencia de Miembros 2025",
    motivationsAndBenefits: "Motivaciones y Beneficios de Miembros"
  },
  demographics: {
    title: "Demografía de Miembros",
    subtitle: "Desglose detallado de educación, empleo y perfil de edad de miembros JCI",
    averageMemberAge: "Edad Promedio de Miembro",
    activeMembers: "Miembros JCI activos en todo el mundo",
    yearsOld: "años",
    educationProfile: "Perfil Educativo",
    source: "Fuente",
    jciMemberSurvey: "Encuesta de Miembros JCI 2025",
    universityEducated: "Educación Universitaria",
    highlyEducated: "Los miembros JCI son profesionales altamente educados",
    employmentStatus: "Estado de Empleo",
    sourceCitation: "Fuente: Encuesta de Miembros JCI 2025 - Datos demográficos oficiales"
  },
  globalMemberProfile: {
    title: "Perfil Global de Miembros",
    surveyDescription: "Encuesta de Experiencia de Membresía 2025 • 3,790 encuestados",
    educationalAttainment: "Nivel Educativo",
    employmentDistribution: "Distribución de Empleo",
    industryDiversity: "Diversidad de Industrias",
    keyInsight: "97%+ de miembros JCI tienen o cursan títulos universitarios",
    entrepreneursInsight: "31% son emprendedores o autónomos",
    primarySectors: "Sectores principales representados por miembros JCI",
    sourceCitation: "Fuente: Datos de Membresía JCI 2025 | Informe de Impacto JCI 2025 | Encuesta de Experiencia de Membresía 2025"
  },
  memberExperience: {
    title: "Panel de Experiencia de Miembros",
    subtitle: "Métricas de satisfacción y engagement de miembros",
    netPromoterScore: "Net Promoter Score",
    npsBreakdown: "Desglose de NPS",
    memberSatisfaction: "Satisfacción de Miembros",
    promoters: "Promotores",
    neutrals: "Neutrales",
    detractors: "Detractores"
  },
  alumniNetwork: {
    title: "Red de Alumni",
    subtitle: "Red global de alumni JCI - impacto más allá de la membresía activa",
    totalAlumni: "Total de Alumni",
    totalAlumniDesc: "Red global de alumni JCI",
    remainingActive: "Alumni Activos",
    remainingActiveDesc: "Mantienen algún nivel de involucramiento post-JCI",
    leadershipPositions: "Posiciones de Liderazgo",
    leadershipPositionsDesc: "En liderazgo corporativo, gubernamental o sin fines de lucro",
    businessOwners: "Dueños de Negocios",
    businessOwnersDesc: "Iniciaron o heredaron negocios"
  },
  eventPreferences: {
    title: "Preferencias de Eventos",
    subtitle: "Tipos de eventos que los miembros más valoran",
    networking: "Eventos de Networking",
    training: "Talleres de Capacitación",
    conferences: "Conferencias",
    community: "Proyectos Comunitarios",
    social: "Eventos Sociales"
  },
  occupationIndustry: {
    title: "Ocupación e Industria",
    subtitle: "Distribución ocupacional y sectores industriales de miembros",
    topOccupations: "Principales Ocupaciones",
    topIndustries: "Principales Industrias",
    entrepreneur: "Emprendedor/Autónomo",
    manager: "Gerente/Director",
    professional: "Profesional",
    consultant: "Consultor",
    executive: "Ejecutivo",
    techIt: "Tecnología/TI",
    finance: "Finanzas/Banca",
    manufacturing: "Manufactura/Industrial",
    healthcare: "Salud",
    consulting: "Consultoría"
  },
  memberInsights: {
    title: "Perspectivas de Miembros JCI",
    subtitle: "Comprender la demografía, motivaciones y habilidades de los miembros",
    demographics: "Demografía de Miembros",
    motivations: "Motivaciones y Valores",
    skills: "Inventario de Habilidades",
    ageDistribution: "Distribución de Edad",
    genderBreakdown: "Desglose de Género",
    educationLevel: "Nivel Educativo",
    employmentStatus: "Estado de Empleo",
    regionalDemographics: "Demografía Regional",
    memberMotivations: "¿Por qué se unen los miembros a JCI?",
    topMotivations: "Motivaciones Principales",
    personalDevelopment: "Desarrollo Personal",
    networking: "Networking y Conexiones",
    communityImpact: "Impacto Comunitario",
    leadershipSkills: "Desarrollo de Habilidades de Liderazgo",
    careerAdvancement: "Avance Profesional",
    globalCitizenship: "Ciudadanía Global",
    motivationsByRegion: "Motivaciones por Región",
    memberSkillsMap: "Mapa de Habilidades de Miembros",
    topSkills: "Habilidades Principales",
    projectManagement: "Gestión de Proyectos",
    publicSpeaking: "Oratoria",
    fundraising: "Recaudación de Fondos",
    digitalMarketing: "Marketing Digital",
    eventPlanning: "Planificación de Eventos",
    dataAnalysis: "Análisis de Datos",
    skillsByCareerStage: "Habilidades por Etapa Profesional",
    earlyCareer: "Carrera Temprana (0-3 años)",
    midCareer: "Carrera Media (4-7 años)",
    experiencedProfessional: "Profesional Experimentado (8+ años)",
    skillsDevelopmentPriorities: "Prioridades de Desarrollo de Habilidades",
    skillsCurrentlyHave: "Habilidades que Tengo",
    skillsWantToDevelop: "Habilidades que Quiero Desarrollar",
    skillGap: "Brecha de Habilidades",
    trainingOpportunities: "Oportunidades de Entrenamiento",
    memberTestimonials: "Testimonios de Miembros",
    readMore: "Leer más",
    testimonialsList: "Lista de Testimonios",
    surveyMethodology: "Metodología de Encuesta",
    sampleSize: "Tamaño de Muestra",
    responseRate: "Tasa de Respuesta",
    surveyPeriod: "Período de Encuesta",
    dataCollection: "Recolección de Datos"
  },
  skillsDevelopment: {
    title: "Panel de Desarrollo de Habilidades",
    headline: "Capacitando 1,969+ Líderes Anualmente",
    heroDescription: "Desarrollar líderes está en el corazón de la misión de JCI. En 2024-2025, JCI entregó capacitación de clase mundial en cuatro Áreas de Oportunidad, alcanzando casi 2,000 miembros con habilidades prácticas.",
    totalParticipants: "Total de Participantes Capacitados",
    members: "miembros",
    leadershipSessions: "Sesiones de Capacitación en Liderazgo",
    globally: "globalmente",
    skillsSessions: "Sesiones de Desarrollo de Habilidades",
    totalSessions: "Total de Sesiones",
    certifiedTrainers: "Red de Entrenadores Certificados",
    activeTrainers: "entrenadores activos",
    certifiedTrainersByRegion: "Entrenadores Certificados por Región",
    region: "Región",
    trainers: "Entrenadores Certificados",
    percentGlobal: "% del Global",
    trainingMultiplier: "Multiplicador de Capacitación",
    asiaPacific: "Asia y el Pacífico",
    africaMiddleEast: "África y Oriente Medio",
    americas: "América",
    europe: "Europa",
    highestCapacity: "Mayor capacidad",
    rapidGrowth: "Crecimiento rápido",
    establishedNetwork: "Red establecida",
    steadyPresence: "Presencia estable",
    cascadingKnowledge: "Cada entrenador puede certificar 5-10 entrenadores adicionales",
    specializedTracks: "Pistas de Capacitación Especializadas",
    publicSpeakingTrack: "Oratoria y Comunicación",
    debatingTrack: "Debate y Pensamiento Crítico",
    trainerCertification: "Programa de Certificación de Entrenadores",
    conferenceTraining: "Profundidad de Capacitación por Conferencia (2025)",
    conference: "Conferencia",
    location: "Ubicación",
    participants: "Participantes",
    sessions: "Sesiones",
    regionalReach: "Alcance Regional",
    skillsCategories: "Categorías de Habilidades Cubiertas",
    leadershipDecision: "Liderazgo y Toma de Decisiones",
    communicationInfluence: "Comunicación e Influencia",
    entrepreneurshipInnovation: "Emprendimiento e Innovación",
    projectManagement: "Gestión de Proyectos y Ejecución",
    civicResponsibility: "Responsabilidad Cívica y Ciudadanía Global",
    memberProgression: "Ruta de Progresión del Miembro",
    stage1: "Etapa 1: Participante",
    stage2: "Etapa 2: Practicante",
    stage3: "Etapa 3: Entrenador Certificado",
    stage4: "Etapa 4: Entrenador Master/Mentor",
    ctaTitle: "Invierte en Tu Jornada de Liderazgo",
    exploreTrainings: "Explorar Capacitaciones Disponibles",
    becomeCertified: "Convertirse en Entrenador Certificado",
    sourceNote: "Fuente: Informe de Impacto JCI 2025 – Datos de Desarrollo de Habilidades"
  },
  jciFoundation: {
    title: "Programa de Subvenciones de la Fundación JCI",
    headline: "$100K+ Anualmente: Financiando Innovación de Miembros",
    heroDescription: "La Fundación JCI representa más que recaudación de fondos—es un compromiso de democratizar oportunidades de liderazgo y asegurar que las grandes ideas no estén limitadas por restricciones presupuestarias.",
    grantsOverTime: "Subvenciones de la Fundación a lo Largo del Tiempo",
    year: "Año",
    totalAwarded: "Total de Subvenciones Otorgadas (USD)",
    trend: "Tendencia",
    interpretation: "Interpretación",
    highInvestment: "Año de alta inversión",
    consolidation: "Fase de consolidación",
    focusOnImpact: "Enfoque en impacto sobre volumen",
    threeYearTotal: "Total de 3 Años: $405,000 invertidos en iniciativas de miembros JCI",
    whatGrantsFund: "Qué Financian las Subvenciones (2024-2025)",
    programsCompetitions: "Competencias de Programas JCI",
    leadershipAcademies: "Academias y Cumbres de Liderazgo",
    entrepreneurshipSupport: "Apoyo a Emprendimiento y Negocios",
    infrastructureSupport: "Secretariado Físico e Infraestructura",
    growthInitiatives: "Iniciativas de Crecimiento y Desarrollo",
    regionalAllocation: "Asignación Regional",
    successStories: "Historias de Éxito de las Subvenciones",
    grantCycle: "Proceso del Ciclo de Subvenciones",
    ctaTitle: "Financia Tu Iniciativa JCI",
    viewOpportunities: "Ver Oportunidades de Subvenciones",
    checkQualify: "Verifica Si Calificas",
    submitProposal: "Enviar una Propuesta",
    sourceNote: "Fuente: Informe Anual de la Fundación JCI 2025"
  },
  jciSenate: {
    title: "Reconocimiento del Senado JCI",
    headline: "84,375 Líderes Vitalicios: El Senado JCI",
    heroDescription: "El Senado JCI es más que un honor—es una membresía vitalicia en una comunidad global de líderes excepcionales.",
    totalSenators: "Total de Senadores Activos",
    allTime: "De Todos los Tiempos",
    newSenators: "Senadores Honrados en 2025",
    newSelections: "nuevas selecciones",
    annualGrowth: "Tasa de Crecimiento Anual",
    sustainableGrowth: "sostenible, enfocado en calidad",
    lifetimeValue: "Valor Vitalicio",
    unlimitedMentorship: "Mentoría, networking y engagement ilimitados",
    demographicsDashboard: "Demografía de los Senadores",
    ageProfile: "Perfil de Edad",
    genderComposition: "Composición de Género",
    male: "Masculino",
    female: "Femenino",
    professionalBackground: "Formación Profesional",
    corporateExecutives: "Ejecutivos Corporativos",
    entrepreneursOwners: "Emprendedores/Propietarios de Negocios",
    educatorsTrainers: "Educadores y Entrenadores",
    governmentPublic: "Gobierno y Sector Público",
    nonprofitSocial: "Sin Fines de Lucro y Social",
    otherFields: "Otros Campos Profesionales",
    valueProposition: "Propuesta de Valor del Senado",
    engagementTiers: "Modelo de Engagement del Senado",
    tier1: "Nivel 1: Mentoría",
    tier2: "Nivel 2: Liderazgo de Programas",
    tier3: "Nivel 3: Liderazgo Organizacional",
    tier4: "Nivel 4: Legado y Advocacy",
    successMetrics: "Métricas de Éxito del Senado",
    ctaTitle: "Únete al Senado JCI",
    understandPath: "Entender el Camino al Senado",
    exploreBenefits: "Explorar Beneficios del Senador",
    becomeMentor: "Convertirse en Mentor",
    nominateLeaders: "Nominar Líderes Excepcionales",
    sourceNote: "Fuente: Registro del Senado JCI 2025"
  }
} as const;
